/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EntityType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Adjustment from './Adjustment/index'
import Charge from './Charge/index'
import ChargeTransfer from './ChargeTransfer/index'
import Correction from './Correction/index'
import InstallmentCharge from './InstallmentCharge/index'
import No from './No/index'
import Payment from './Payment/index'
import PaymentPlan from './PaymentPlan/index'
import React from 'react'
import TransferCharge from './TransferCharge/index'



/** @type {import('Simple/types.js').View} */
export default function EntityType({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Content/Content/Transaction/EntityType"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let entryDtypeValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'dtype',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: entryDtypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Adjustment'}>
<Adjustment
  viewPath={`${viewPath}/Adjustment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Correction'}>
<Correction
  viewPath={`${viewPath}/Correction`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Charge'}>
<Charge
  viewPath={`${viewPath}/Charge`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InstallmentCharge'}>
<InstallmentCharge
  viewPath={`${viewPath}/InstallmentCharge`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentPlan'}>
<PaymentPlan
  viewPath={`${viewPath}/PaymentPlan`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ChargeTransfer'}>
<ChargeTransfer
  viewPath={`${viewPath}/ChargeTransfer`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TransferCharge'}>
<TransferCharge
  viewPath={`${viewPath}/TransferCharge`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Payment'}>
<Payment
  viewPath={`${viewPath}/Payment`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}